"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _fuse = _interopRequireDefault(require("fuse.js"));

var _core = require("@material-ui/core");

var _Map = _interopRequireDefault(require("@material-ui/icons/Map"));

var _ViewList = _interopRequireDefault(require("@material-ui/icons/ViewList"));

var _solarReact = require("@solar/solar-react");

var _solarReact2 = require("@probeton/solar-react");

var _UnitList = _interopRequireDefault(require("./UnitList"));

var _UnitMap = _interopRequireDefault(require("./UnitMap"));

var _excluded = ["units", "loading", "title", "labels"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UnitSearch = function UnitSearch(_ref) {
  var units = _ref.units,
      loading = _ref.loading,
      title = _ref.title,
      labels = _ref.labels,
      other = _objectWithoutProperties(_ref, _excluded);

  var fuseSearchMemoized = (0, _react.useMemo)(function () {
    if (loading) {
      return null;
    }

    var options = {
      keys: ['name', 'primaryContact.fullName', 'location.formatted_address', 'key'],
      shouldSort: true,
      threshold: 0.3
    };
    var fuse = new _fuse["default"](units, options);
    return (0, _ramda.memoizeWith)(_ramda.identity, function (search) {
      return fuse.search(search);
    });
  }, [loading, units ? units.length : 0]);

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = (0, _react.useState)('list'),
      _useState4 = _slicedToArray(_useState3, 2),
      view = _useState4[0],
      setView = _useState4[1];

  var filteredUnits = search === '' || loading ? (0, _ramda.sortBy)((0, _ramda.prop)('name'))(units) : fuseSearchMemoized(search); // console.log(filteredUnits);

  return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    fullColumn: true
  }, /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveAppBar, {
    title: title,
    actions: /*#__PURE__*/_react["default"].createElement(_solarReact2.ResponsiveSearchField, {
      InputProps: {
        id: 'searchOffice'
      },
      placeholder: labels.search,
      value: search,
      onChange: function onChange(value) {
        return setSearch(value);
      }
    }),
    extraToolbar: /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      onClick: function onClick() {
        setView(view === 'map' ? 'list' : 'map');
      },
      style: {
        color: 'white'
      }
    }, view === 'map' ? /*#__PURE__*/_react["default"].createElement(_ViewList["default"], null) : /*#__PURE__*/_react["default"].createElement(_Map["default"], null))
  }), /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, loading ? /*#__PURE__*/_react["default"].createElement(_core.LinearProgress, {
    color: "primary"
  }) : '', view === 'map' ? /*#__PURE__*/_react["default"].createElement(_UnitMap["default"], _extends({
    units: filteredUnits
  }, other)) : /*#__PURE__*/_react["default"].createElement(_solarReact.ScrollableContent, null, /*#__PURE__*/_react["default"].createElement(_UnitList["default"], _extends({
    units: filteredUnits
  }, other)))));
};

var _default = UnitSearch;
exports["default"] = _default;